import React, {useState, useEffect, useMemo} from 'react';
import { useTranslation } from "react-i18next";
import { makeStyles } from '@mui/styles';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import {httpClient} from '../../../core/HttpClient'
import TextField from "@mui/material/TextField";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import LinkOffIcon from '@mui/icons-material/LinkOff';
import Dialog from "@mui/material/Dialog";
import Alert from "@mui/material/Alert";
import Snackbar from "@mui/material/Snackbar";
import {Radio, RadioGroup} from "@mui/material";
import FormControlLabel from "@mui/material/FormControlLabel";
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { Carousel } from 'react-responsive-carousel';
import {LoadingButton} from "@mui/lab";
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import Divider from "@mui/material/Divider";

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
    },
    link: {
        color: theme.palette.primary.main,
        textDecoration: 'none'
    },
    tabs: {
        borderBottom: '1px solid #e8e8e8',

    },
    tabPanels: {
        '& .MuiBox-root': {
            padding: '0px',
        },
    },
    actionControl: {
        marginTop: '1rem'
    },
    boxLeft: {
        padding: theme.spacing(1),
        textAlign: 'left'
    },
    boxRight: {
        padding: theme.spacing(1),
        textAlign: 'right'
    },
    itemSave: {
        order: 1,
        [theme.breakpoints.up('sm')]: {
            order: 2,
        },
    },
    itemCancel: {
        order: 2,
        [theme.breakpoints.up('sm')]: {
            order: 1,
        },
    },
    media: {
        height: 0,
        paddingTop: '52.35%', // 1.91:1 Facebook OG Image
    },
    cardContent: {
        padding: 15,
        "&:last-child": {
            paddingBottom: 15
        },
        "& canvas": {
            width: '100%'
        }
    },
    paper: {
        position: 'absolute',
        width: '100%',
        backgroundColor: theme.palette.background.paper,
        border: '0px',
        boxShadow: theme.shadows[5],
        padding: theme.spacing(2, 4, 3),
    },
}));

function Item(props)
{
    return (
        <Box>
            <img className='CarouselImage'
                 src={props.item.image} alt={props.item.name} width="100%"/>
        </Box>
    )
}

interface RichMenu {
    name: string;
    code: string;
    image: string;
    height: string;
}

const richMenu: RichMenu[] = [
    {
        name: "Menu #1",
        code: "A01",
        image: "https://cdn.foodkub.com/public/richmenu/A01.jpg",
        height: "350px"
    },
    {
        name: "Menu #2",
        code: "A02",
        image: "https://cdn.foodkub.com/public/richmenu/A02.jpg",
        height: "350px"
    },
    {
        name: "Menu #3",
        code: "A03",
        image: "https://cdn.foodkub.com/public/richmenu/A03.jpg",
        height: "350px"
    }
];

export default function LineOASetting(params) {
    const {t} = useTranslation();
    const classes = useStyles();
    const [lineOA, setLineOA] = useState({
        channelID: '',
        channelSecret: '',
        richMenu: 'INACTIVE',
        richMenuDefault: ''
    });
    const [connected, setConnected] = useState(false);
    const [initial, setInitial] = useState(true);
    const [loading, setLoading] = useState(false);
    const [openConfirm, setOpenConfirm] = useState(false);
    const [alertMessage, setAlertMessage] = React.useState({
        open: false,
        state: 'error',
        message: 'lineOA.connectionError',
    });
    const [errors, setErrors] = useState([]);
    const [richMenuIndex, setRichMenuIndex] = useState(0);
    const [richMenuName, setRichMenuName] = useState('');

    const richMenuItems = useMemo(() => { return [...richMenu] }, []);


    useEffect(() => {
        console.log('[LineOASettings]');
        const lineNotifyUrl = process.env.REACT_APP_API_BASE_URL + '/lineoa';
            httpClient.get(lineNotifyUrl)
        .then(res => {
            if(res.data){
                let richMenuIndex = richMenuItems.findIndex(x => x.code === res.data.richMenuCode);
                if(richMenuIndex > -1){
                    setRichMenuIndex(richMenuIndex);
                    setRichMenuName(richMenuItems[richMenuIndex].name);
                }
                setLineOA(res.data);
                if(res.data.channelID && res.data.channelSecret){
                    setConnected(true);
                }
            }
            setInitial(false);
        });
    }, [richMenuItems]);

    const handleChange = ({ target }) => {
        setLineOA({ ...lineOA, [target.name]: target.value });
    };

    const handleConnectLineOA = () => {

        let errors = [];
        if(!lineOA.channelID){
            errors.push('channelID');
        }
        if(!lineOA.channelSecret){
            errors.push('channelSecret');
        }

        setErrors(errors);
        if(errors.length > 0){
            return;
        }

        setLoading(true);
        const url = process.env.REACT_APP_API_BASE_URL + '/lineoa';
        httpClient.post(url, lineOA)
            .then(res => {
                if(res.status === 200){
                    setLineOA(res.data);
                    setConnected(true);
                } else {
                    setAlertMessage({...alertMessage, open: true, state: 'error', message: 'lineOA.connectionError'});
                }
                setLoading(false);
            }).catch(err=>{
            setAlertMessage({...alertMessage, open: true, state: 'error', message: 'lineOA.connectionError'});
                setLoading(false);
            });
    };

    const handleSaveRichMenu = () => {

        setLoading(true);
        let richMenuCode = '';
        if(lineOA.richMenu === 'ACTIVE'){
            let richMenuItem = richMenuItems[richMenuIndex];
            richMenuCode = richMenuItem.code;
        }

        const url = process.env.REACT_APP_API_BASE_URL + '/lineoa/richmenu';
        httpClient.post(url, {...lineOA, richMenuCode: richMenuCode})
            .then(res => {
                if(res.status === 200){
                    setLineOA(res.data);
                    setConnected(true);
                    setAlertMessage({...alertMessage, open: true, state: 'success', message: 'common.message.saveSuccess'});
                } else {
                    setAlertMessage({...alertMessage, open: true, state: 'error', message: 'common.message.saveFail'});
                }
                setLoading(false);
            }).catch(err=>{
                setAlertMessage({...alertMessage, open: true, state: 'error', message: 'common.message.saveFail'});
                setLoading(false);
            });
    };

    const handleDisconnect = () => {

        const url = process.env.REACT_APP_API_BASE_URL + '/lineoa/disconnect';
        httpClient.post(url, lineOA)
            .then(res => {
                setLineOA({
                    channelID: '',
                    channelSecret: '',
                    richMenu: 'INACTIVE',
                    richMenuCode: '',
                });
                setConnected(false);
                setOpenConfirm(false);
            });
    };

    // const handleRichMenuChange = (now, previous) => {
    //     if(now > richMenuItems.length - 1){
    //         return;
    //     }
    //     if(now < 0){
    //         return;
    //     }
    //     setRichMenuIndex(now);
    //     setRichMenuName(richMenuItems[richMenuIndex].name);
    // };

    const handleClickOpenConfirm = () => {
        setOpenConfirm(true);

    };

    const handleCloseConfirm = () => {
        setOpenConfirm(false);
    };

    const handleAlertMessageClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }

        setAlertMessage({...alertMessage, open: false});
    };

    const handleNext = () => {
        let currentIndex = richMenuIndex;
        currentIndex++;
        if(currentIndex > richMenuItems.length - 1){
            return;
        }
        if(currentIndex < 0){
            return;
        }

        setRichMenuIndex(currentIndex);
        setRichMenuName(richMenuItems[currentIndex].name);
    };

    const handlePrevious = () => {
        let currentIndex = richMenuIndex;
        currentIndex--;
        if(currentIndex > richMenuItems.length - 1){
            return;
        }
        if(currentIndex < 0){
            return;
        }

        setRichMenuIndex(currentIndex);
        setRichMenuName(richMenuItems[currentIndex].name);
    };

    return (
        <Box>
            <form className={classes.root} noValidate autoComplete="off">
                <Box display="flex" justifyContent="space-between" alignItems="center" m={1}>
                    <Typography variant="h6">
                        {t('lineOA.title')}
                    </Typography>
                </Box>
                <Divider style={{'marginBottom': '10px', 'marginTop': '10px'}} />
                <Box m={1}>
                    <Card className={classes.root} variant="outlined" style={{marginBottom: '0.8rem'}}>
                        {!initial && !connected &&
                            <>
                                <CardContent>
                                    <Typography className={classes.title} color="textSecondary" gutterBottom>
                                        {t('lineOA.setting')}
                                    </Typography>
                                    <Box mt={2}>
                                        <TextField label={t('lineOA.channelID')} variant="outlined" fullWidth={true}
                                                   name="channelID"
                                                   value={lineOA.channelID}
                                                   required
                                                   onChange={handleChange}
                                                   error={errors.indexOf('channelID') > -1} />
                                    </Box>
                                    <Box mt={2}>
                                        <TextField label={t('lineOA.channelSecret')} variant="outlined" fullWidth={true}
                                                   name="channelSecret"
                                                   value={lineOA.channelSecret}
                                                   error={errors.indexOf('channelSecret') > -1}
                                                   required
                                                   onChange={handleChange} />
                                    </Box>
                                </CardContent>
                                <CardActions>
                                    <Button disabled={loading} variant="contained" size="large" disableElevation color="primary" fullWidth={true} onClick={handleConnectLineOA}>
                                        {t('lineOA.connect')}
                                    </Button>
                                </CardActions>
                            </>
                        }
                        {!initial && connected &&
                            <>
                                <CardContent>
                                    <Typography className={classes.title} color="textSecondary" gutterBottom>
                                        {t('lineOA.setting')}
                                    </Typography>
                                    <Box mt={2} display="flex" justifyContent="space-between">
                                        <Box>{t('lineOA.channelID')}</Box>
                                        <Box>{lineOA.channelID}</Box>
                                    </Box>
                                    <Box mt={1} display="flex" justifyContent="space-between">
                                        <Box>{t('lineOA.channelSecret')}</Box>
                                        <Box>&#8226;&#8226;&#8226;&#8226;&#8226;&#8226;&#8226;&#8226;&#8226;&#8226;&#8226;&#8226;&#8226;&#8226;</Box>
                                    </Box>
                                    <Box mt={1}  display="flex" justifyContent="space-between" alignItems="center">
                                        <Box>{t('lineOA.connectionStatus')}</Box>
                                        <Box display="flex" justifyContent="center" alignItems="center">
                                            <Box mr={1}>{t('lineOA.connected')}</Box>
                                            <Button variant="text" disableElevation color="primary"
                                                    sx={{ minHeight: 0, minWidth: 0, padding: 0 }}
                                                    onClick={handleClickOpenConfirm} >({t('common.cancel')})
                                            </Button>
                                        </Box>
                                    </Box>
                                </CardContent>
                            </>
                        }
                    </Card>
                    {!initial && connected &&
                        <Box m={1}>
                            <Typography className={classes.title} color="textSecondary" gutterBottom>
                                {t('lineOA.richMenuSetting')}
                            </Typography>
                            <Box>
                                <RadioGroup
                                    aria-labelledby="richMenu"
                                    name="richMenu"
                                    value={lineOA.richMenu}
                                    onChange={handleChange}
                                >
                                    <FormControlLabel value="INACTIVE" control={<Radio />} label={t('lineOA.richMenuInactive')} />
                                    <FormControlLabel value="ACTIVE" control={<Radio />} label={t('lineOA.richMenuActive')} />
                                </RadioGroup>
                            </Box>
                            {lineOA.richMenu === 'ACTIVE' &&
                                <>
                                    <Box mt={2} display="flex" justifyContent="space-between" alignItems="center">
                                        <Button variant="outlined"
                                                color="primary"
                                                size="large"
                                                disableElevation
                                                disabled={richMenuIndex === 0}
                                                onClick={handlePrevious}>
                                            <ChevronLeftIcon />
                                        </Button>
                                        <h2>{richMenuName}</h2>
                                        <Button variant="outlined"
                                                color="primary"
                                                size="large"
                                                disableElevation
                                                disabled={richMenuIndex === richMenuItems.length - 1}
                                                onClick={handleNext}>
                                            <ChevronRightIcon />
                                        </Button>
                                    </Box>
                                    <Box display="flex" justifyContent="center" alignItems="center">
                                        <Carousel
                                            selectedItem={richMenuIndex || 0}
                                            autoPlay={false}
                                            swipeable={false}
                                            infiniteLoop={false}
                                            showIndicators={false}
                                            showThumbs={false}
                                            showArrows={false}
                                            showStatus={false}
                                            // onChange={handleRichMenuChange}
                                        >
                                            {
                                                richMenuItems.map( (item, i) => <Item key={i} item={item} /> )
                                            }
                                        </Carousel>
                                    </Box>
                                </>
                            }
                            <Box mt={2}>
                                <Box display="flex" justifyContent="flex-end">
                                    <LoadingButton loading={loading}
                                                   variant="contained"
                                                   color="primary"
                                                   disableElevation
                                                   size="large"
                                                   fullWidth={true}
                                                   onClick={(e) => handleSaveRichMenu()}
                                                   disabled={loading}>
                                        {t('common.save')}
                                    </LoadingButton>
                                </Box>
                            </Box>
                        </Box>
                    }
                </Box>
            </form>
            <Dialog
                fullWidth
                open={openConfirm}
                onClose={handleCloseConfirm}
                aria-labelledby="alert-dialog-slide-title"
                aria-describedby="alert-dialog-slide-description"
            >
                <DialogTitle id="alert-dialog-slide-title">{t('common.confirm')}</DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-slide-description">
                        {t('lineOA.cancelConnectionMessage')}
                    </DialogContentText>
                </DialogContent>
                <Box m={2}>
                    <Box mb={2}>
                        <Button variant="contained"
                                color="secondary"
                                size="large"
                                disableElevation
                                fullWidth={true}
                                startIcon={<LinkOffIcon />}
                                onClick={(e) => handleDisconnect(e)}>
                            {t('lineOA.cancelConnection')}
                        </Button>
                    </Box>
                    <Box>
                        <Button variant="contained"
                                color="grey"
                                onClick={handleCloseConfirm}
                                fullWidth={true}
                                size="large"
                                disableElevation>
                            {t('common.cancel')}
                        </Button>
                    </Box>
                </Box>
            </Dialog>
            <Snackbar open={alertMessage.open}
                      anchorOrigin={{vertical:'top', horizontal:'center'}}
                      autoHideDuration={3000} onClose={handleAlertMessageClose}>
                <Alert onClose={handleAlertMessageClose} severity={alertMessage.state}>
                    <Box>
                        {t(alertMessage.message)}
                    </Box>
                </Alert>
            </Snackbar>
        </Box>
    )
}